<template>
  <input
    ref="slider"
    type="range"
    v-bind="{ ...$props, ...$attrs }"
    class="m-0 w-48 webkit-slider-thumb:w-6 moz-range-thumb:w-6 ms-thumb:w-6 h-2 webkit-slider-thumb:h-6 moz-range-thumb:h-6 ms-thumb:h-6 webkit-slider-thumb:bg-primary-400 webkit-slider-runnable-track:bg-transparent moz-range-track:bg-transparent moz-range-thumb:bg-primary-400 ms-track:bg-transparent ms-thumb:bg-primary-400 moz-range-thumb:rounded-none webkit-slider-thumb:border-none moz-range-thumb:border-none outline-none -rotate-90 origin-[96px_96px] appearance-none webkit-slider-thumb:appearance-none webkit-slider-runnable-track:cursor-pointer bg-shade-alpha-900"
    :value="modelValue"
    @input="handleInput"
  />
</template>
<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Number,
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()

const slider = ref(null)
const upgradeSliderBackground = () => {
  const max = slider.value.max
  const min = slider.value.min
  const visibleWidth = ((slider.value.value - min) * 100) / (max - min)
  const fillLeft = '#f26224' // color: primary-400
  const fillRight = 'rgba(0,0,0,.25)' // color: shade-alpha-900
  // console.log(
  //   max,
  //   min,
  //   slider.value.value,
  //   visibleWidth,
  //   `linear-gradient(to right, ${fillLeft} ${visibleWidth}%, ${fillRight} ${visibleWidth}%)`
  // )

  slider.value.style.background = `linear-gradient(to right, ${fillLeft} ${visibleWidth}%, ${fillRight} ${visibleWidth}%)`
}
const handleInput = (e) => {
  upgradeSliderBackground()
  emit('update:modelValue', Number(e.target.value))
}

onMounted(() => {
  upgradeSliderBackground()
})
</script>
